"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Random = void 0;
var Random = (function () {
    function Random() {
    }
    Random.rangeFloat = function (start, end) {
        if (end === void 0) { end = 0; }
        return start + Math.random() * (end - start);
    };
    Random.range = function (start, end) {
        return Math.floor(Random.rangeFloat(start, end));
    };
    Random.bool = function (probability) {
        if (probability === void 0) { probability = 0.5; }
        return Math.random() <= probability;
    };
    Random.sign = function (probability) {
        if (probability === void 0) { probability = 0.5; }
        return (Random.bool(probability) ? 1 : -1);
    };
    Random.UUID = function (dt) {
        if (dt === void 0) { dt = Date.now(); }
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        });
    };
    Random.from = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length > 1) {
            return args[Math.floor(args.length * Math.random())];
        }
        var first = args[0];
        if (Array.isArray(first)) {
            return first[Math.floor(first.length * Math.random())];
        }
        return first;
    };
    return Random;
}());
exports.Random = Random;
//# sourceMappingURL=Random.js.map